var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-area-tree" },
    [
      _c(
        "yxt-row",
        [
          _c("yxt-input", {
            ref: "input",
            staticClass: "yxtbiz-area-tree__input",
            style: { width: _vm.inputW },
            attrs: {
              size: _vm.size,
              placeholder: _vm
                .$t("pc_biz_shoptour_search_key")
                .d("请输入区域名称搜索"),
              searchable: "",
              clearable: "",
            },
            on: { search: _vm.search },
            model: {
              value: _vm.searchText,
              callback: function ($$v) {
                _vm.searchText = $$v
              },
              expression: "searchText",
            },
          }),
        ],
        1
      ),
      _c("yxtbiz-funs-tree", {
        ref: "tree",
        staticClass: "mt16",
        attrs: {
          data: _vm.data,
          props: _vm.defaultProps,
          "wrap-width": _vm.wrapWidth,
          "node-key": _vm.nodeKey,
          "default-expand-all": _vm.defaultExpandAll,
          "default-expanded-keys": _vm.expendedRoot,
          "show-checkbox": "",
          "check-strictly": "",
          "check-on-click-node": "",
          functions: "",
          functionsRender: _vm.functionsRender,
          "filter-node-method": _vm.filterNode,
          dropdownToBody: _vm.dropdownToBody,
          virtual: "",
          keeps: 50,
          buffer: 10,
        },
        on: { "node-click": _vm.nodeClick, check: _vm.handlerCheck },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }